import type { ReactNode } from "react";
import ReactMarkdown from "react-markdown";

import { Link } from "../link";

function A({ children, href }: { children?: ReactNode; href?: string }) {
  if (!href) return <></>;
  return (
    <Link
      // CMS 本文中のリンクで、導線として設計されていない
      data-analytics-ignore
      className="underline"
      href={href}
    >
      {children}
    </Link>
  );
}

export function Markdown({ children }: { children: string }) {
  return (
    <ReactMarkdown
      components={{
        a: A,
      }}
    >
      {children}
    </ReactMarkdown>
  );
}
